var _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconCompleted(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 43,
    height: 43,
    viewBox: "0 0 43 43",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M42.3633 21.3633C42.3633 32.9613 32.9613 42.3633 21.3633 42.3633C9.7653 42.3633 0.363281 32.9613 0.363281 21.3633C0.363281 9.7653 9.7653 0.363281 21.3633 0.363281C32.9613 0.363281 42.3633 9.7653 42.3633 21.3633Z",
    fill: "#E3F0FF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M21.3633 39.4667C31.3615 39.4667 39.4667 31.3615 39.4667 21.3633C39.4667 11.365 31.3615 3.25983 21.3633 3.25983C11.365 3.25983 3.25983 11.365 3.25983 21.3633C3.25983 31.3615 11.365 39.4667 21.3633 39.4667ZM21.3633 42.3633C32.9613 42.3633 42.3633 32.9613 42.3633 21.3633C42.3633 9.7653 32.9613 0.363281 21.3633 0.363281C9.7653 0.363281 0.363281 9.7653 0.363281 21.3633C0.363281 32.9613 9.7653 42.3633 21.3633 42.3633Z",
    fill: "#A9D1FF"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M33.597 13.908C34.4528 14.6651 34.5329 15.9727 33.7758 16.8285L22.0149 30.1234C21.1881 31.0581 19.7628 31.1526 18.8198 30.3353L11.2159 23.7453C10.3524 22.9969 10.2591 21.6903 11.0075 20.8268C11.7558 19.9633 13.0625 19.8699 13.926 20.6183L20.1369 26.0011L30.6765 14.0868C31.4336 13.231 32.7411 13.1509 33.597 13.908Z",
    fill: "#166DD7"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconCompleted);
export default __webpack_public_path__ + "static/media/icon-completed.127f6833f9b8c55b687abd216c61c912.svg";
export { ForwardRef as ReactComponent };